var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { TaskGroupView } from "./TaskGroupView";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { Card, Grid, GridColumn, Separator, Table } from "@atlassiansox/microscopekit";
import { PremiseDetailView } from "./PremiseDetailView";
import { useSendScreenEvent } from "../analytics";
var TemplatePreview = function (props, ref) {
    var _a, _b;
    var _c = __read(useState(props.wargameTemplate), 2), wargameTemplate = _c[0], setWargameTemplate = _c[1];
    useImperativeHandle(ref, function () { return ({
        refresh: function (wargameTemplate) {
            setWargameTemplate(wargameTemplate);
        }
    }); });
    useSendScreenEvent("createWargamePlanTemplatePreviewStep");
    return (React.createElement("div", null,
        React.createElement(Grid, { layout: "flex" },
            React.createElement(GridColumn, { medium: 6 },
                React.createElement(Table, { title: "Basic Information", cells: [
                        ["name", wargameTemplate.name ? wargameTemplate.name : ""],
                        [
                            "environment",
                            wargameTemplate.environment ? wargameTemplate.environment : ""
                        ]
                    ] }))),
        React.createElement(Grid, { layout: "flex" },
            React.createElement(GridColumn, { medium: 6 }, wargameTemplate.premise ? ((_a = wargameTemplate.premise) === null || _a === void 0 ? void 0 : _a.map(function (premise) { return (React.createElement(PremiseDetailView, { premise: premise })); })) : (React.createElement(Card, null, "Premise not configured")))),
        React.createElement(Grid, { layout: "flex" },
            React.createElement(Separator, null),
            React.createElement("h4", null, "Task Group List"),
            React.createElement(Separator, null),
            React.createElement(GridColumn, { medium: 12 }, (_b = wargameTemplate.taskGroup) === null || _b === void 0 ? void 0 : _b.map(function (taskGroup, index) { return (React.createElement(TaskGroupView, { taskGroup: taskGroup, index: index, isCollapsedInitially: false, key: "TaskGroup:" + index })); })))));
};
export default forwardRef(TemplatePreview);
